// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-large-text-fe28c5bb"};